/* eslint-disable max-classes-per-file */
export class DuplicateContactException extends Error {
  // `data` lists the offending attributes (e.g. ['email']); `serverMessage`
  // keeps the human-readable reason the API sent so callers can surface it
  // when the attribute is not one they have a dedicated message for.
  constructor(data, serverMessage = '') {
    super('DUPLICATE_CONTACT');
    this.data = data;
    this.serverMessage = serverMessage;
    this.name = 'DuplicateContactException';
  }
}

export class ExceptionWithMessage extends Error {
  constructor(data) {
    super('ERROR_WITH_MESSAGE');
    this.data = data;
    this.name = 'ExceptionWithMessage';
  }
}
